var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ManageMedicationIcon = function (_a) {
    var props = __rest(_a, []);
    return (_jsxs("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", __assign({ fillRule: "evenodd", clipRule: "evenodd", d: "M8 6C7.44772 6 7 6.44772 7 7V16C7 16.5523 7.44772 17 8 17C8.55228 17 9 16.5523 9 16V13H10.5858L12.5858 15L11.2929 16.2929C10.9024 16.6834 10.9024 17.3166 11.2929 17.7071C11.6834 18.0976 12.3166 18.0976 12.7071 17.7071L14 16.4142L15.2929 17.7071C15.6834 18.0976 16.3166 18.0976 16.7071 17.7071C17.0976 17.3166 17.0976 16.6834 16.7071 16.2929L15.4142 15L16.7071 13.7071C17.0976 13.3166 17.0976 12.6834 16.7071 12.2929C16.3166 11.9024 15.6834 11.9024 15.2929 12.2929L14 13.5858L12.8082 12.394C13.5322 11.8463 14 10.9778 14 10V9.5C14 7.567 12.433 6 10.5 6H8ZM11 11H9V8H10.5C11.3284 8 12 8.67157 12 9.5V10C12 10.5523 11.5523 11 11 11Z", fill: "currentColor" }, props)), _jsx("path", __assign({ fillRule: "evenodd", clipRule: "evenodd", d: "M6 0C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21V3C21 1.34315 19.6569 0 18 0H6ZM5 3C5 2.44772 5.44771 2 6 2H18C18.5523 2 19 2.44772 19 3V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V3Z", fill: "currentColor" }, props))] })));
};
